import { useState, useEffect } from "react"
import { USDottruck } from "../../../images"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../BottomBar/bottombar"
import AlertIcon from "components/AlertIcon/alertIcon"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { useTranslation } from "react-i18next"

const GateLinkUSDOT = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [disabledPhone, setdisabledPhone] = useState(false)
  const [LoadReferenceNumber, setLoadReferenceNumber] = useState("")
  const [invalidPhone, setinvalidPhone] = useState(false)
  const [USDOT, setUSDOT] = useState("")
  const [companyName, setcompanyName] = useState("")

  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const setCompanyDetails = () => {
    let asset = {
      ...assetReducer.asset,
      usdot: USDOT,
      companyName: companyName
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })

    // history.push("/tractor-info")
    localStorage.setItem("previousPath", "carrier-info")
    history.push({
      pathname: "/dispatch-details",
      state: "/event-tracking"
    })
  }

  const handlePaste = (e: any, limit: number, elementName: string) => {
    if (elementName == "companyName") {
      let trunc = companyName.substring(0, limit)
      setcompanyName(trunc)
    }
    if (elementName == "USDOT") {
      let truncUSDOT = USDOT.substring(0, limit)
      setUSDOT(truncUSDOT)
    }
  }
  useEffect(() => {
    if (USDOT.trim().length > 0 && companyName.trim().length > 0) {
      setdisabledProceed(false)
    } else {
      setdisabledProceed(true)
    }
  }, [USDOT, companyName])

  // Here used "carrier name" for display purposes and "company name" to process in the code
  // Both names refer same

  const usdot_number_not_valid = t("usdot_number_not_valid")
  const enter_your_us_dot_number = t("enter_your_us_dot_number")
  const enter_your_carrier = t("enter_your_carrier")
  const carrier_not_valid = t("carrier_not_valid")

  return (
    <>
      <div className="container">
        <div className="gl-header-text">{t("enter_your_carrier_details")} </div>
        <div
          className={` driver-input driver-input-USDOT-font ${
            invalidPhone ? "error-label" : ""
          }`}
        >
          <Input
            autoFocus={true}
            className={`${invalidPhone ? "error-label" : ""}`}
            placeholder={t("enter_usdot_here") || ""}
            label={enter_your_us_dot_number}
            value={USDOT}
            disabled={disabledPhone}
            hideLabel={false}
            name="usdot"
            maxLength={20}
            onChange={event => setUSDOT(event.target.value)}
            onPaste={e => handlePaste(e, 20, "USDOT")}
            invalid={invalidPhone}
            errorLabel={invalidPhone ? usdot_number_not_valid : ""}
            icon={
              invalidPhone ? (
                <AlertIcon className="elemental-Input-icon--invalid" />
              ) : (
                <></>
              )
            }
          />
        </div>
        <div
          className={`driver-input driver-input-usdot driver-input-USDOT-font${
            invalidPhone ? "error-label" : ""
          }`}
        >
          <Input
            className={`${invalidPhone ? "error-label" : ""}`}
            placeholder={t("enter_your_carrier_name_here")}
            label={enter_your_carrier}
            value={companyName}
            onPaste={e => handlePaste(e, 50, "companyName")}
            disabled={disabledPhone}
            maxLength={50}
            onChange={event => setcompanyName(event.target.value)}
            invalid={invalidPhone}
            errorLabel={invalidPhone ? carrier_not_valid : ""}
            icon={
              invalidPhone ? (
                <AlertIcon className="elemental-Input-icon--invalid" />
              ) : (
                <></>
              )
            }
          />
        </div>
        <img src={USDottruck} />
        <div className="info"></div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setCompanyDetails()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}
export default GateLinkUSDOT
